import { useTranslation } from 'react-i18next'

const BigSisterStart = (props) => {
  const { t } = useTranslation()
  
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="bigsister-start-title"
      {...props}
    >
      <title id="bigsister-start-title">{t('antagonists:bigsister:components:start')}</title>
      <defs>
        <clipPath id="big-sister-b">
          <path
            d="M1608.3 958.27s-3.61 11.48-4.04 18.28c-.43 6.8.43 15.09 1.7 16.15 1.28 1.06 13.6 2.98 20.4 3.83 6.8.85 8.93.85 10.63 2.98 1.7 2.13 3.83 5.53 12.33 6.59 8.5 1.06 39.11-2.98 39.11-2.98s2.98-8.5-4.46-14.24c-7.44-5.74-17.85-9.78-23.38-20.19-5.53-10.41-3.83-17.22-14.45-17-10.63.21-14.03 8.29-19.55 9.99s-14.67-6.16-18.28-3.4Z"
            style={{
              fill: '#b0983a',
            }}
          />
        </clipPath>
        <clipPath id="big-sister-c">
          <path
            d="M1471.26 956.87c-9.04-1.39-11.47 2.09-15.65 12.17-4.17 10.08-2.43 12.86-11.82 17.73-9.39 4.87-13.21 7.65-14.26 10.78-1.04 3.13-1.39 10.08-1.39 10.08s31.29 4.52 41.03 1.74c9.74-2.78 5.56-8 15.3-9.39 9.74-1.39 26.77-4.87 29.21-6.95 2.43-2.09 1.04-14.26.7-20.17-.35-5.91-5.91-17.38-5.91-17.38s-4.87 8.69-17.04 8.34c-17.78-.51-11.13-5.56-20.17-6.95Z"
            style={{
              fill: '#b0983a',
            }}
          />
        </clipPath>
        <clipPath id="big-sister-d">
          <path
            d="M1528.5 390.36s.74-12.07-5.45-22.78c-14.07-24.34-11.01-39.82-11.01-39.82s-38.87 8.71-52.75 10.81c-13.88 2.1-24.26 7.92-24.68 29.38-.42 21.46 17.67 85.4 13.46 112.74-4.21 27.34-21.46 55.53-18.51 69.41 2.94 13.88 16.83 18.93 16.41 25.24-.42 6.31.76 23.65.76 23.65s40.04 9.17 67.81 8.33c27.77-.84 96.13-8.33 96.13-8.33s-3.21-16.22 3.94-21.27c7.15-5.05 9.83-6.75 10.26-20.21.42-13.46-16.93-51.59-12.72-76.41s2.1-63.52 12.2-85.82c10.1-22.3 12.2-33.66 2.1-40.39-10.1-6.73-61.21-24.09-61.21-24.09s-1.34 8.2-7.89 17.82c-5.61 8.24-15.01 15.7-17.73 19.97-5.89 9.26-7.4 21.27-7.4 21.27l-3.71.49Z"
            style={{
              fill: '#e6ab00',
            }}
          />
        </clipPath>
        <style>
          {
            '.e{fill:none}.f{fill:#f9cec6}.g{fill:#e6f1e2}.h{fill:#e6ab00}.i{fill:#8cabbc}.j{fill:#b0983a}.k{fill:#de9766}.l{fill:#c48648}.m{fill:#245787}.n{fill:#1c3628}.o{clip-path:url(#big-sister-c)}.p{clip-path:url(#big-sister-b)}.q{clip-path:url(#big-sister-d)}'
          }
        </style>
      </defs>
      <path
        d="M1540.55 308.67c-40.3-3.65-51.87-1.47-56.92 10.73-5.05 12.2 15.63 75.8 15.63 75.8l48.3 9.99s21.07-25.65 36.64-41.63c15.57-15.99 14.48-33.58 11.12-43.25-3.37-9.68-20.76-8.55-54.76-11.63Z"
        style={{
          fill: '#e6ab00',
        }}
      />
      <path
        style={{
          fill: '#f9cec6',
        }}
        d="m1530.53 336.2 38.21 1.33-38.21 68.28h-26.08l-17.96-63.24 44.04-6.37z"
      />
      <path
        d="M1506.55 289.7s6.96 33.62 5.47 41.23c-1.33 6.81 4.08 18.67 18.81 19.09s27.89-3.53 31.68-8.57c3.79-5.05 3.37-52 3.37-52l-59.32.26Z"
        style={{
          fill: '#c48648',
        }}
      />
      <path
        style={{
          fill: '#8cabbc',
        }}
        d="m1615.53 944.67 2.98 24.23 34.85-7.86-5.31-22.32-32.52 5.95zM1471.85 944.67s-1.49 10.2-5.1 14.24c-3.61 4.04-5.53 11.69-5.53 11.69s46.97-1.28 46.12-1.28c-.85 0-1.7-25.08-1.7-25.08l-33.8.43Z"
      />
      <path
        d="M1608.3 958.27s-3.61 11.48-4.04 18.28c-.43 6.8.43 15.09 1.7 16.15 1.28 1.06 13.6 2.98 20.4 3.83 6.8.85 8.93.85 10.63 2.98 1.7 2.13 3.83 5.53 12.33 6.59 8.5 1.06 39.11-2.98 39.11-2.98s2.98-8.5-4.46-14.24c-7.44-5.74-17.85-9.78-23.38-20.19-5.53-10.41-3.83-17.22-14.45-17-10.63.21-14.03 8.29-19.55 9.99s-14.67-6.16-18.28-3.4Z"
        style={{
          fill: '#b0983a',
        }}
      />
      <g
        style={{
          clipPath: 'url(#big-sister-b)',
        }}
      >
        <path
          d="M1601.24 979.61s7.02 5.22 18.36 6.48 12.96 3.6 17.82 6.48c4.86 2.88 16.74 1.8 27.18 1.62 10.44-.18 30.78-3.06 30.78-3.06l3.06 29.7-97.01-13.86-.18-27.36Z"
          style={{
            fill: '#e6ab00',
          }}
        />
      </g>
      <path
        d="M1504.86 550.47c30.67 4.23 101.53-1.59 98.89-1.06s11.11 67.16 7.93 115.28l-3.17 48.12s0 34.37 5.82 59.76c5.82 25.38 15.68 41.52 19.91 72.2 4.23 30.67 11.82 89.1 11.82 89.1l-47.07 12.16s-.53-10.05-5.82-17.98-7.93-15.86-13.22-45.48-13.75-76.68-17.45-95.19c-3.7-18.51-57.64-236.91-57.64-236.91Z"
        style={{
          fill: '#245787',
        }}
      />
      <path
        d="M1461.5 537.25s-16.39 59.76-15.34 93.07c1.06 33.32 16.92 116.34 18.51 136.97 1.59 20.62-4.09 44.19-3.7 58.7.31 11.82 8.99 115.81 8.99 115.81l48.12 14.28s-5.82-12.69 3.17-20.62c8.99-7.93 5.82-30.14 4.23-61.87-1.59-31.73-7.93-64.52-7.93-82.5 0-17.98 1.49-78.68 4.76-90.96 5.27-19.79 20.1-69.81 17.45-68.22-2.64 1.59 0-90.43 0-90.43l-78.27-4.23Z"
        style={{
          fill: '#245787',
        }}
      />
      <path
        d="M1471.26 956.87c-9.04-1.39-11.47 2.09-15.65 12.17-4.17 10.08-2.43 12.86-11.82 17.73-9.39 4.87-13.21 7.65-14.26 10.78-1.04 3.13-1.39 10.08-1.39 10.08s31.29 4.52 41.03 1.74c9.74-2.78 5.56-8 15.3-9.39 9.74-1.39 26.77-4.87 29.21-6.95 2.43-2.09 1.04-14.26.7-20.17-.35-5.91-5.91-17.38-5.91-17.38s-4.87 8.69-17.04 8.34c-17.78-.51-11.13-5.56-20.17-6.95Z"
        style={{
          fill: '#b0983a',
        }}
      />
      <g
        style={{
          clipPath: 'url(#big-sister-c)',
        }}
      >
        <path
          d="M1423.93 995.88s12.34 3.09 22.97 3.09c10.63 0 22.97.34 27.43-1.37 4.46-1.71 9.6-5.14 17.83-7.54 8.23-2.4 17.83-5.14 20.57-6.17 2.74-1.03 10.29-5.83 10.29-5.83l4.11 31.55-113.16 23.66v-27.78l9.94-9.6Z"
          style={{
            fill: '#e6ab00',
          }}
        />
      </g>
      <path
        d="M1629.47 358.84c12.2 16.83 39.24 108.18 41.52 128.4 2.33 20.67-21.37 57.67-27.11 64.5-7.37 8.76-39.73 14.36-39.73 14.36l-11.36-32.39s22.3-29.87 29.03-41.23c6.73-11.36-22.3-66.89-22.3-66.89l29.95-66.74ZM1453.12 344.81s-12.62 0-17.25 11.78c-4.63 11.78-22.72 53.01-30.71 76.14-7.99 23.14-16.83 32.39-10.94 50.48 5.89 18.09 8.55 49.75 19.06 58.59 10.52 8.83 25.95 11.25 25.95 11.25l10.52-45.01s-14.72-31.13-15.57-37.02c-.84-5.89 35.34-39.12 35.34-39.12l-16.41-87.08Z"
        style={{
          fill: '#e6ab00',
        }}
      />
      <path
        d="M1528.5 390.36s.74-12.07-5.45-22.78c-14.07-24.34-11.01-39.82-11.01-39.82s-38.87 8.71-52.75 10.81c-13.88 2.1-24.26 7.92-24.68 29.38-.42 21.46 17.67 85.4 13.46 112.74-4.21 27.34-21.46 55.53-18.51 69.41 2.94 13.88 16.83 18.93 16.41 25.24-.42 6.31.76 23.65.76 23.65s40.04 9.17 67.81 8.33c27.77-.84 96.13-8.33 96.13-8.33s-3.21-16.22 3.94-21.27c7.15-5.05 9.83-6.75 10.26-20.21.42-13.46-16.93-51.59-12.72-76.41s2.1-63.52 12.2-85.82c10.1-22.3 12.2-33.66 2.1-40.39-10.1-6.73-61.21-24.09-61.21-24.09s-1.34 8.2-7.89 17.82c-5.61 8.24-15.01 15.7-17.73 19.97-5.89 9.26-7.4 21.27-7.4 21.27l-3.71.49Z"
        style={{
          fill: '#e6ab00',
        }}
      />
      <g
        style={{
          clipPath: 'url(#big-sister-d)',
        }}
      >
        <path
          d="M1528.76 387.61s-4.44 56.44-9.03 72.37c-4.59 15.93-10.55 40.33-11.63 58.14-1.08 17.82-1.89 93.45-1.89 93.45h5.03s-.63-75.5.99-92.93c1.59-17.06 7.21-44.74 10.53-55.34 5.31-16.95 9.23-74.19 9.23-74.19l-3.24-1.51Z"
          style={{
            fill: '#f9cec6',
          }}
        />
      </g>
      <path
        d="m1594.28 939.99 7.67 29.39s3.8 1.22 19.53-7.28 32.31-8.93 32.31-8.93l-6.38-25.29s-13.6-.21-25.93 4.25-17.22 8.08-20.62 8.5c-3.4.43-6.59-.64-6.59-.64ZM1464.83 928.48l-1.76 29.05s12.18-1.19 20.68 2.64 15.82 7.98 21.56 9.68c5.74 1.7 10.53.12 10.53.12l3.56-25.2s-.94 4.49-14.61-3.49c-11.36-6.63-15.23-8.45-21.25-9.78-7.7-1.69-18.71-3.01-18.71-3.01Z"
        style={{
          fill: '#e6f1e2',
        }}
      />
      <path
        style={{
          fill: 'none',
        }}
        d="m1528.33 388.71-1.13 24.42 11.47-1.85-5.81-23.1-4.53.53z"
      />
      <path
        d="M1542.52 212.56c-7.73-1.8-13.45-3.94-20.83 0s-9.57 8.06-13.26 8.63c-3.69.58-12.02 2.94-11.66 12.19.36 9.25 9.65 8.46 9.5 13.17s-1.63 12.96-2.62 20.18c-.98 7.22.24 19.32.24 19.32s69.99 7.5 69.35 7.45c-.64-.05 3.14-13.06 4.26-19.19 1.11-6.14 1.62-9.96 3.55-10.02 1.94-.07 10.48 1.48 11.87-8.28 1.39-9.76-3.92-8.7-3.53-13.82.39-5.12.63-11.1-6.7-16.17-7.33-5.07-9.88-2.69-12.62-6.11-2.74-3.43-2.71-6.64-10.04-8.92-7.33-2.28-12.05 2.85-17.53 1.58Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1541.43 244.09c-12.53-1.6-21.32-.07-24.26 1.75-6.94 4.27-1.45 10.41-6.34 15.39-4.89 4.99-4.67 14.91-4.67 14.91s-.54-6.91-5.48-6.85-8.28 7.3-6.65 14.08c1.63 6.77 3.41 11.89 5.89 12.68 2.3.73 4.59-1.15 4.59-1.15s-.95 12.37 2.73 20.37c3.68 8 13.46 17.55 18.12 18.33 4.66.79 12.07 2 16.89.65s19.19-9.69 22.71-16.49c3.52-6.81 4.64-15.73 4.64-15.73s3.84 3.08 6.84.31 7.07-5.91 7.98-12.27c.92-6.36.97-9.35-3.51-9.69-4.48-.34-8.54 7.93-8.54 7.93s1.8-12.3.16-16.07c-1.64-3.77-3.13-3.89-3.46-7.99-.33-4.1.8-10.45-6.83-14.46-7.63-4.02-20.8-5.67-20.8-5.67Z"
        style={{
          fill: '#c48648',
        }}
      />
      <path
        d="M1547.31 274.19s6.26-3.82 12.52-3.63c5.49.16 7.63 2.11 7.63 2.11l1.31-2.54s-3.27-2.75-11.39-3.79c-8.13-1.04-11.92 2.68-11.92 2.68l1.86 5.17ZM1533.78 272.22s-7.05-4.99-12.54-5.3c-5.46-.31-7.14.74-7.14.74l-.91-2.71s3.65-2.22 11.84-2.02c8.19.21 11.82 3.69 11.82 3.69l-3.07 5.61Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1520.37 305.78c-.43 1.88 3.4 8.88 12.34 10.12 8.95 1.24 17.8-2.18 18.41-4.64.61-2.46-2.27-8.17-7.26-8.42-4.99-.24-7.91.94-7.91.94s-2.33-4.09-6.39-3.15c-4.33 1.01-8.57 2.41-9.2 5.14Z"
        style={{
          fill: '#de9766',
        }}
      />
      <path
        style={{
          fill: '#1c3628',
        }}
        d="m1548.31 277.99 10.99-.57-.5-4.21-11.42 2.08.93 2.7zM1519.58 272.55l11.57 3.16.4-3.33-10.48-3.94-1.49 4.11z"
      />
      <path
        d="M1523.52 273.28c-2.02-.24-3.61.94-3.77 2.93-.16 1.99 1.03 2.95 2.83 3.28 2.13.39 3.5-.75 3.87-2.78.26-1.43-.86-3.18-2.94-3.44ZM1552.4 276.85c-2.02-.24-3.61.94-3.77 2.93-.16 1.99 1.03 2.95 2.83 3.28 2.13.39 3.5-.75 3.87-2.78.26-1.43-.86-3.18-2.94-3.44Z"
        style={{
          fill: '#1c3628',
        }}
      />
      <path
        d="M1441.22 518.88s6.46-5.08 11-5.68c4.54-.6 15.01.58 19.36.51 4.35-.07 12.49.15 12.49.15s-.33 6.14-4.71 7.66c-4.38 1.51-18.29.24-18.32 1.69-.03 1.45 15.19.76 19.73-.02 4.54-.79 7.74-5.77 10.67-7.32 2.93-1.55 5.82-1.29 5.82-1.29l-1.24 14.26s-6.02 9.61-8.29 13.9c-2.27 4.28-5.6 7.27-8.72 9-2.11 1.17-21.59 6.95-21.59 6.95l-21.16-7.69s-2.38-9.05-2.21-15.92c.16-6.87 7.18-16.18 7.18-16.18Z"
        style={{
          fill: '#c48648',
        }}
      />
    </svg>
  )
}

export default BigSisterStart

